import React, { useEffect, useReducer } from "react";
import { Card, CardHeader, CardBody, Spinner } from "reactstrap";
import { getAward } from "states/person/PersonDatasource";
import PersonReducer from "states/person/PersonReducer";
import { FETCH_SUCCESS, FETCH_FAILED } from "states/person/PersonType";
import _ from "lodash"

const INIT_DATA = {
  loading: true,
  data: null,
  itemsCount: 0,
};
const ITEM_LIMIT = 10;
export default function AwardSection({ staffId }) {
  const [state, dispatch] = useReducer(PersonReducer, INIT_DATA);

  const fetchData = async () => {
    try {
      const resp = await getAward(staffId);

      if (resp.status === 1) {
        const payload = {
          data: _.orderBy(resp.result, ['year'], ['desc']),
          itemsCount: resp.itemsCount,
        };
        return dispatch({ type: FETCH_SUCCESS, payload });
      } else {
        return dispatch({ type: FETCH_FAILED, error: "Fetch failed" });
      }
    } catch (error) {
      return dispatch({ type: FETCH_FAILED, error: error.message });
    }
  };

  useEffect(() => {
    if (state.loading) {
      if (staffId) {
        setTimeout(() => {
          fetchData();
        }, 1000);
      } else {
        console.log("No id to query");
      }
    }
  });

  const renderItems = (data) => {
    if (data.length > 0) {
      let renderItems = [];
      let displayItems = []
      const filterItems = data.filter((item) => item.show === true);

      if (filterItems.length <= 0) {
        renderItems = data;
      } else {
        renderItems = filterItems;
      }

      renderItems.forEach((item, index) => {
        if (index < ITEM_LIMIT) {
          displayItems.push(
            <li key={index}>
              <div className="title">{item.title ? item.title : "-"}</div>
            </li>
          )
        }
      });

      return displayItems
    }
    return (
      <li>
        <p className="text-nodata">ไม่พบข้อมูล</p>
      </li>
    );
  };

  return (
    <div className="section">
      <Card className="card-section">
        <CardHeader>
          <i className="fas fa-award"></i>
          <span> รางวัล/หนังสือ/ตำรา/อื่นๆ</span>
        </CardHeader>
        <CardBody>
          {!state.data ? (
            <div className="text-center">
              <Spinner />
            </div>
          ) : (
            <ul className="list-unstyled list-data">
              {renderItems(state.data)}
            </ul>
          )}
        </CardBody>
      </Card>
    </div>
  );
}
